var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4173 15.9001C16.3956 15.9001 15.5674 16.7284 15.5674 17.7501C15.5674 18.7718 16.3956 19.6 17.4173 19.6C18.439 19.6 19.2672 18.7718 19.2672 17.7501C19.2672 16.7284 18.439 15.9001 17.4173 15.9001Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58136 3.40012C5.55966 3.40012 4.73142 4.22836 4.73142 5.25006C4.73142 6.27175 5.55966 7.1 6.58136 7.1C7.60305 7.1 8.4313 6.27175 8.4313 5.25006C8.4313 4.22836 7.60305 3.40012 6.58136 3.40012Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 18.166L7.83315 18.166C5.99229 18.166 4.49997 16.6737 4.49997 14.8328V14.8328C4.49997 12.992 5.99229 11.4997 7.83315 11.4997L16.1661 11.4997C18.007 11.4997 19.4993 10.0073 19.4993 8.16649V8.16649C19.4993 6.32562 18.007 4.83331 16.1661 4.83331L11.9996 4.83331",
    stroke: "#333333",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostProcessing);
export default __webpack_public_path__ + "static/media/post_processing.61d77ceadfe2488ba6bea20122dcc609.svg";
export { ForwardRef as ReactComponent };